


















/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import { PARKING_LOT_LIST, PARKING_LOT_EDIT } from '../router-names';
import { DEFAULT_DATE_FORMAT } from '@/common/config';
import { DEVICE_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import AddDeviceForm from './components/add-device-form.vue';
import { editInfoDeviceList } from '@/api/parking-lot-management/index';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddDeviceForm }
})
export default class DeviceListEdit extends Vue {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  path = '/smart-parking/parking-lot-management/device-list/';
  formData = {}; // 表单数据
  deviceId: string = '';
  headTitle = '设备编辑';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '设备信息',
        location: {
          name: DEVICE_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 生命周期函数
  created() {
    this.deviceId = this.$route.params.deviceId;
    this.queryEditInfoDeviceList(this.$route.params.deviceId);
  }

  async queryEditInfoDeviceList(deviceId: string) {
    const { status, code, msg, data } = await editInfoDeviceList({ deviceId });
    this.formData = data;
    // this.formData.push = deviceId
  }
  // 编辑成功
  isSubmitOk(values: any) {
    this.goBack();
  }
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: DEVICE_LIST
    });
  }
  /**
   * 查询数据整合获取
   */
  // get filterParam() {
  //   return {
  //     parkId: this.parkId,
  //     areaName: this.areaName,
  //     areaId: this.areaId,
  //   }
  // }
}
